var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartDietPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25C14 25 0 17.0455 0 7.38637C0.000284969 5.67918 0.583315 4.02477 1.64996 2.70444C2.71661 1.3841 4.20104 0.479333 5.85087 0.143962C7.50069 -0.19141 9.21408 0.0633155 10.6997 0.86483C12.1854 1.66635 13.3515 2.96517 14 4.54049L14 4.5405C14.6484 2.96518 15.8146 1.66635 17.3003 0.864836C18.7859 0.0633187 20.4993 -0.191409 22.1491 0.143962C23.799 0.479332 25.2834 1.3841 26.35 2.70443C27.4167 4.02477 27.9997 5.67918 28 7.38637C28 17.0455 14 25 14 25Z",
    fill: "#348287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDietPlan);
export default __webpack_public_path__ + "static/media/smart-diet-plan.c4828aef20c0aa8dbeca65dd8e7ce111.svg";
export { ForwardRef as ReactComponent };